export default "__VITE_PUBLIC_ASSET__da8aa802__"